module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clum2right left"
  }, [_c('div', {
    staticClass: "left",
    attrs: {
      "id": "content_block"
    }
  }, [_c('div', {
    staticClass: "content_icon left"
  }), _vm._v(" "), _c('div', {
    staticClass: "content_title left"
  }, [_vm._v("HOW TO UPDATE?")]), _vm._v(" "), _c('div', {
    staticClass: "left",
    attrs: {
      "id": "content_main"
    }
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": require("../../assets/images/step-01.png"),
      "width": "140",
      "height": "160",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "setpfonts"
  }, [_vm._v("Register an account")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../assets/images/step-arrow.png"),
      "width": "30",
      "height": "160",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../assets/images/step-02.png"),
      "width": "140",
      "height": "160",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "setpfonts"
  }, [_vm._v("Download update tool and install on PC")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../assets/images/step-arrow.png"),
      "width": "30",
      "height": "160",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../assets/images/step-03.png"),
      "width": "140",
      "height": "160",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "setpfonts"
  }, [_vm._v("Login update tool and download maps")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../assets/images/step-arrow.png"),
      "width": "30",
      "height": "160",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../assets/images/step-04.png"),
      "width": "140",
      "height": "160",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "setpfonts"
  }, [_vm._v("Install updates")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "left spcacetop",
    attrs: {
      "id": "content_block"
    }
  }, [_c('div', {
    staticClass: "content_icon left"
  }), _vm._v(" "), _c('div', {
    staticClass: "content_title left"
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('div', {
    staticClass: "left",
    attrs: {
      "id": "qandalist"
    }
  }, [_c('ol', [_c('li', [_c('div', {
    staticClass: "titel3"
  }, [_vm._v("UPDATE YOUR NAVIGATION’S MAP")]), _vm._v(" "), _c('div', {
    staticClass: "con3"
  }, [_vm._v("Find out how to update the latest map into your navigation device here.")]), _vm._v(" "), _c('div', {
    staticClass: "btn3"
  }, [_c('button', {
    staticClass: "pure-button button-warning login_input",
    attrs: {
      "onclick": "window.open('http://maptool.polnav.com.tw/manual/Motrex_ENG-1.pdf','_blank')"
    }
  }, [_vm._v("CLICK HERE")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "titel3"
  }, [_vm._v("INSTALL THE MAP UPDATE TOOL")]), _vm._v(" "), _c('div', {
    staticClass: "con3"
  }, [_vm._v("Find out how to install the Map Updater 3 to update your latest map here.")]), _vm._v(" "), _c('div', {
    staticClass: "btn3"
  }, [_c('button', {
    staticClass: "pure-button button-warning login_input",
    attrs: {
      "onclick": "window.open('http://maptool.polnav.com.tw/manual/Motrex_ENG-2.pdf','_blank')"
    }
  }, [_vm._v("CLICK HERE")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "titel3"
  }, [_vm._v("PURCHASE OR DOWNLOAD UPDATES")]), _vm._v(" "), _c('div', {
    staticClass: "con3"
  }, [_vm._v("Find out how to purchase or download the latest map updates here.")]), _vm._v(" "), _c('div', {
    staticClass: "btn3"
  }, [_c('button', {
    staticClass: "pure-button button-warning login_input",
    attrs: {
      "onclick": "window.open('http://maptool.polnav.com.tw/manual/Motrex_ENG-3.pdf','_blank')"
    }
  }, [_vm._v("CLICK HERE")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51be244e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/LoginContent.vue
// module id = 109
// module chunks = 1